"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddSavedPaymentMethod = void 0;
const tslib_1 = require("tslib");
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const internal_1 = require("../internal");
/**
 * Adds a saved payment method.
 */
const useAddSavedPaymentMethod = (props) => {
    const { authState, savedPaymentMethodClient, previewOptions } = props;
    const getCustomerToken = (0, internal_1.useGetCustomerAccessToken)({ authState });
    const { isAuthenticated } = authState;
    const [error, setError] = (0, react_1.useState)();
    const [isFetching, setIsFetching] = (0, react_1.useState)(false);
    const [savedPaymentMethod, setSavedPaymentMethod] = (0, react_1.useState)();
    const addSavedPaymentMethod = (0, react_1.useCallback)((createSavedPaymentMethodRequest) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
        var _a;
        if (!isAuthenticated) {
            return;
        }
        try {
            setIsFetching(true);
            const accessToken = yield getCustomerToken();
            const response = yield savedPaymentMethodClient.addSavedPaymentMethod(createSavedPaymentMethodRequest, {
                accessToken,
                preview: previewOptions
            });
            setError(undefined);
            setSavedPaymentMethod(response);
            return response;
        }
        catch (error) {
            if (axios_1.default.isCancel(error)) {
                // do nothing if cancelled
                return;
            }
            if (axios_1.default.isAxiosError(error)) {
                setError((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                return;
            }
            setError(error);
            return;
        }
        finally {
            setIsFetching(false);
        }
    }), [
        savedPaymentMethodClient,
        getCustomerToken,
        isAuthenticated,
        previewOptions
    ]);
    return {
        savedPaymentMethod: savedPaymentMethod,
        addSavedPaymentMethod: addSavedPaymentMethod,
        error,
        isFetching
    };
};
exports.useAddSavedPaymentMethod = useAddSavedPaymentMethod;
//# sourceMappingURL=use-add-saved-payment-method.js.map